<template>
  <div id="puzzle-container" v-if="currentImage != null" :style="{backgroundSize: tile.width + 'px ' + tile.height + 'px'}" @mousemove="mouseMove">
    <div class="rows" v-for="row in currentImage.rows" :key="row">
      <div class="columns" v-for="column in currentImage.columns" :key="column">
        <div class="piece" :id="row + '' + column" @mousedown="mouseDown" :style="[{top: 100*(row -1 ) + 'px', left: 100*(column -1) + 'px', height: tile.height + 'px', width: tile.width + 'px', background: 'url(' + currentImage.src + ') -' +((column - 1) * tile.width) + 'px -' + ((row - 1) * tile.height) + 'px / ' + (currentImage.columns * tile.width) + 'px ' + (currentImage.rows * tile.height) + 'px'}]">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import srcClick from './assets/click.mp3';
import srcRelease from './assets/release.mp3';
import srcComplete from './assets/complete.mp3';

var audioClick = new Audio(srcClick);
var audioRelease = new Audio(srcRelease);
var audioComplete = new Audio(srcComplete);

export default {
  data() {
    return {
      margin: 25,
      activePiece: null,
      tile: {
        height: 100,
        width: 100,
      },
      delta: 5,
      offsetX: 0,
      offsetY: 0,
      maxHeight: 500,
      maxWidth: 800,
      activeHeight: 0,
      activeWidth: 0,
      zIndex: 1,
    };
  },
  props: ['activeImage'],
  computed: {
    currentImage() {
      if (this.activeImage != null) {
        var currentImage = this.activeImage;

        if (currentImage.width > currentImage.height) {
          this.activeHeight =
            currentImage.height / currentImage.width * this.maxWidth;
          this.activeWidth = this.maxWidth;
        } else {
          this.activeHeight = this.maxHeight;
          this.activeWidth =
            currentImage.width / currentImage.height * this.maxHeight;
        }

        this.tile.height = Math.round(this.activeHeight / currentImage.rows);
        this.tile.width = Math.round(this.activeWidth / currentImage.columns);

        this.$nextTick().then(() => {
          this.scramble();
        });

        return currentImage;
      }
    },
  },
  mounted() {
    document.addEventListener('mouseup', event => {
      if (this.activePiece != null) {
        this.activePiece.style.border = '0px';
        this.activePiece.style.zIndex--;

        if (this.activePiece.snapped) {
          audioRelease.play();
        }

        this.activePiece = null;
        this.offsetX = 0;
        this.offsetY = 0;

        this.validate();
      }
    });
  },
  methods: {
    mouseDown(event) {
      event.preventDefault();
      this.activePiece = event.target;
      this.offsetX = event.offsetX;
      this.offsetY = event.offsetY;
      this.zIndex++;
      event.target.style.zIndex = this.zIndex;
      audioClick.play();
    },
    mouseMove(event) {
      event.preventDefault();
      if (this.activePiece != null) {
        var xSnap = false;
        var ySnap = false;
        var middleX =
          event.clientX - this.margin - this.offsetX + this.tile.width / 2;
        var anchorX =
          this.tile.width *
            Math.ceil((event.clientX - this.margin) / this.tile.width) -
          this.tile.width / 2;
        var deltaX = this.tile.width / this.delta;
        var deltaXtrigger = Math.abs(anchorX - middleX);

        if (deltaXtrigger <= deltaX) {
          this.activePiece.style.left =
            this.tile.width *
              Math.ceil((event.clientX - this.margin) / this.tile.width) -
            this.tile.width +
            'px';
          xSnap = true;
        } else {
          this.activePiece.style.left =
            event.clientX - this.margin - this.offsetX + 'px';
          xSnap = false;
        }

        var middleY =
          event.clientY - this.margin - this.offsetY + this.tile.height / 2;
        var anchorY =
          this.tile.height *
            Math.ceil((event.clientY - this.margin) / this.tile.height) -
          this.tile.height / 2;
        var deltaY = this.tile.height / this.delta;
        var deltaYtrigger = Math.abs(anchorY - middleY);

        if (deltaYtrigger <= deltaY) {
          this.activePiece.style.top =
            this.tile.height *
              Math.ceil((event.clientY - this.margin) / this.tile.height) -
            this.tile.height +
            'px';
          ySnap = true;
        } else {
          this.activePiece.style.top =
            event.clientY - this.margin - this.offsetY + 'px';
          ySnap = false;
        }

        if (xSnap && ySnap) {
          this.activePiece.snapped = true;
        } else {
          this.activePiece.snapped = false;
        }
      }
    },

    validate() {
      var pieces = document.getElementsByClassName('piece');
      var previousPiece = null;
      var previousColumn = null;
      var previousRow = null;

      var success = null;
      var root = this;
      [].forEach.call(pieces, piece => {
        var row = piece.id.substring(0, 1);
        var column = piece.id.substring(1);
        if (previousPiece == null) {
          previousPiece = piece;
          previousRow = row;
          previousColumn = column;
        } else if (success == null || success) {
          var topIsGood = false;
          var leftIsGood = false;

          if (previousRow == row) {
            // same row
            if (piece.offsetTop == previousPiece.offsetTop) {
              success =
                piece.offsetLeft - previousPiece.offsetLeft == root.tile.width;
            } else {
              success = false;
            }
          } else if (previousRow == row - 1) {
            // new row
            if (piece.offsetTop - root.tile.height == previousPiece.offsetTop) {
              success =
                previousPiece.offsetLeft +
                  root.tile.width -
                  root.currentImage.columns * root.tile.width ==
                piece.offsetLeft;
            } else {
              success = false;
            }
          }

          previousPiece = piece;
          previousRow = row;
          previousColumn = column;
        }
      });

      if (success) {
        this.puzzleFinished();
      }
    },
    puzzleFinished() {
      audioComplete.play();
    },
    scramble() {
      var pieces = document.getElementsByClassName('piece');
      var parent = document.getElementById('puzzle-container');
      console.log(parent.clientWidth);
      [].forEach.call(pieces, piece => {
        piece.style.top =
          Math.floor(Math.random() * (parent.clientHeight - this.tile.height)) +
          'px';

        if (Math.random() >= 0.5) {
          piece.style.left =
            Math.floor(Math.random() * parent.clientWidth / 6) + 'px';
        } else {
          piece.style.left =
            parent.clientWidth -
            Math.floor(Math.random() * parent.clientWidth / 6) -
            this.tile.width +
            'px';
        }
      });
    },
  },
};
</script>

<style scoped>
#puzzle-container {
  height: 100%;
  overflow: hidden;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.3) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
}

.piece {
  position: absolute;
  background-size: cover;
  background-color: white;
  cursor: pointer;
  z-index: 1;
}

.piece:hover {
  outline: none;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/Puzzle.vue